module.exports = __webpack_public_path__ + "img/store_logo.07083804.png";